'use strict';

module.exports = Object.freeze({
  'personal_blog': 'Personal Blog',
  'friends_family': 'Friends / Family',
  'public_group': 'Public Group',
  'private_group': 'Private Group',
  'organization': 'Organization',
  'editorial_board': 'Editorial Board',
  'public_subgroup': 'Public Subgroup',
  'private_subgroup': 'Private Subgroup',
});
